import React, { useRef, useState, useEffect } from 'react';
import Select from 'react-select';

const CategoryForm = ({
    create_new=false,

    categoryName="",

    categoryfield="",
    categoryOptions=[],
    categoryDefaultValue=[],

    subCategoryfield="",
    subCategoryOptions={},
    subCategoryDefaultValue=[]
}) => {

    const [currentCategory, setCurrentCategory] = useState(categoryDefaultValue[0])
    const [currentSubCatgories, setCurrentSubCatgories] = useState(subCategoryDefaultValue)
    const subCategoryRef = useRef(null)

    useEffect(() => {
        var subCategoryfieldInput = document.getElementById(subCategoryfield)
        subCategoryfieldInput.value = JSON.stringify(currentSubCatgories.map((v => v['value'])))
    }, [currentSubCatgories])

    useEffect(() => {
        var categoryfieldInput = document.getElementById(categoryfield)
        categoryfieldInput.value = currentCategory['value']

    }, [currentCategory])

    return (
        <>
            <div class="field">
                <div className="px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <div className="text-sm font-medium text-gray-500">      
                        <div>     
                            <span className="p-2 flex-1 w-0 break-all w-full ">Category</span>
                        </div>
                    </div>
                    <div className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                        {
                        (create_new)?
                            <Select
                                defaultValue={categoryDefaultValue}
                                isMulti={false}
                                options={categoryOptions}
                                onChange={(value) => {
                                    setCurrentCategory(value)
                                    subCategoryRef.current.state.value = []
                                    var categoryfieldInput = document.getElementById(categoryfield)
                                    categoryfieldInput.value = value['value']
                                }}
                            />
                            :
                            <span>{categoryName}</span>
                        }
                    </div>
                </div>
            </div>
            <div class="field">
                <div className="px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <div className="text-sm font-medium text-gray-500">      
                        <div>     
                            <span className="p-2 flex-1 w-0 break-all w-full ">Sub Category</span>
                        </div>
                    </div>
                    <div className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                        <Select
                            ref={subCategoryRef}
                            defaultValue={subCategoryDefaultValue}
                            isMulti={true}
                            options={(currentCategory['label'] in subCategoryOptions)? subCategoryOptions[currentCategory['label']]:[]}
                            onChange={(value) => {
                                setCurrentSubCatgories(value)
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default CategoryForm;